// Plain function rather than part of the hook so getServerSideProps can use it.
export var getTopicNavBehaviour = function (enrolment) {
    switch (enrolment) {
        case 'treatment':
            return 'category-page';
        case 'default-tshirts':
        case 'dynamic-query':
            return enrolment;
        default:
            return 'legacy-nav';
    }
};
